<script>
    import {GenerateRandomColor, GenerateRandomCharName} from "../util/generators.js"
    import Text_field from "../util/Text_field.svelte"
    import Text_area from "../util/Text_area.svelte"
    import { onMount } from 'svelte';
    export let mod_index, updateCallback, values;

    //let color = "#E79846"

    onMount(() => {
		if(values.color == ''){
            values.color = GenerateRandomColor('HSL')
            updateCallback(mod_index, 'color', values.color)
        }
	});

</script>

<div class="grid_wapper">
    <div class="pic" style="background-color:{values.color};"></div>
    <input type="input" class="name" value={values.name} placeholder={'Name • ' + GenerateRandomCharName()} on:blur={(val) => {updateCallback(mod_index, 'name', val.target.value)}}/>
    <Text_field align='end' placeholder="Role" value={values.role} area='role' index={mod_index} field_store_name='role' updateCallback={updateCallback}></Text_field>

    <Text_field align='end' placeholder="Faction" value={values.faction} area='faction' index={mod_index} field_store_name='faction' updateCallback={updateCallback}></Text_field>
    <!--
        <textarea class="description" value={values.description} placeholder="Description • tropes • relations • wants • obstacles • arcs" on:blur={(val) => {updateCallback(mod_index, 'description', val.target.value)}}/>
<div class="description">
        <Text_area value={values.description} placeholder="Description • tropes • relations • wants • obstacles • arcs" area='description' index={mod_index} field_store_name='description' updateCallback={updateCallback}/>
    </div>
    -->
    <Text_area padding_top='1.5em' value={values.description} placeholder="Description • tropes • relations • wants • obstacles • arcs" area='description' index={mod_index} field_store_name='description' updateCallback={updateCallback}/>

</div>

<style lang="scss">
    @use "styles/global.scss";

    .grid_wapper{
        @include module;
        width: 512px;
        height: 660px;
        
        display: grid;
        grid-template-columns: 128px auto auto;
        grid-template-rows: 52px 52px auto;
        grid-template-areas: 
            "pic name name"
            "pic role faction"
            "description description description";

        .pic{
            grid-area: pic;
            width: 128px;
            height: 128px;
            border-radius: 18px;

            justify-self: center;
            align-self: center;

            background-color: $accent_orange;

            transition: all 0.5s ease-in;
        }

        .name{
            @include input_text_form_field($justify:stretch, $align:start, $text:center);
            grid-area: name;

            //margin-top: 24px;
            align-self: center;

            font-style: normal;
            font-weight: bold;
            font-size: 34px;
        }

        .role{
            @include input_text_form_field($justify:center, $align:end, $text:start, $margin-bot:24px);
            grid-area: role;
        }

        .faction{
            @include input_text_form_field($align:end, $text:end, $margin-bot:24px);
            grid-area: faction;
            margin-right: 24px;
            width: auto;
        }
    }

</style>